import createEvent from "./BaseEvent";

const namespace = "address";

export const CountrySelectEvent = createEvent(namespace, "country:select");
